<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2020-12-17 09:38:25
 * @LastEditors: xzx
 * @LastEditTime: 2020-12-26 16:04:59
-->
<template>
    <div class="p-inputgroup" style="max-height: 100%;">
        <!-- 头部内容 -->
        <span class="p-inputgroup-addon" @click="prefixClick" v-if="prefixIcon || $slots.prefix">
            <slot name="prefix" v-if="type !== 'textarea'"></slot>
            <i :class="prefixIcon" v-if="prefixIcon"></i>
        </span>

        <span class="p-input-icon-left p-input-icon-right" style="width: -webkit-fill-available;" v-if="leftIcon || rightIcon">
            <i :class="leftIcon" />
            <InputText :class="[ size ? 'p-inputtext-' + size : '' ]" style="width: inherit;" :placeholder="readonly? '' : placeholder" :type="type" v-model="text" :disabled="readonly" @input="input" @blur="blur" @focus="focus" @keyup.enter="enter" />
            <i :class="rightIcon" />
        </span>
        <InputText v-else :class="[ size ? 'p-inputtext-' + size : '' ]" :placeholder="readonly? '' : placeholder" :type="type" v-model="text" :disabled="readonly" @input="input" @blur="blur" @focus="focus" @keyup.enter="enter" />

        <!-- 绑定条件 -->
        <span class="p-inputgroup-addon" v-if="data_source.columns">
            <i class="pi pi-ellipsis-h" @click="openBindingDialog"></i>
        </span>

        <!-- 尾部内容 -->
        <span class="p-inputgroup-addon" @click="suffixClick" v-if="suffixIcon || $slots.suffix">
            <slot name="suffix" v-if="type !== 'textarea'"></slot>
            <i :class="suffixIcon"></i>
        </span>

        <OverlayPanel ref="op">
            <div class="tw-input-binding-condition">
                <InputText class="tw-input-binding-condition-input" v-model="keyword" placeholder="请输入查询条件"/>
                <Button class="tw-input-binding-condition-btn" label="查询" @click="clickQuery($event)" />
            </div>

            <tw-grid-view :data_source="data_source" size="sm" :pagination="true" @rowSelect="onSelect"></tw-grid-view>
        </OverlayPanel>
    </div>
</template>

<script>
import { computed, ref } from 'vue'
import InputText from 'primevue/inputtext';
import OverlayPanel from 'primevue/overlaypanel';
import Button from 'primevue/button';

export default {
    name: 'tw-input',
    components: {
        InputText,
        OverlayPanel,
        Button,
    },
    props: {
        modelValue: null,
        placeholder: {
            default: '请输入内容'
        },
        type: {
            type: String,
            default: 'text'
        },
        readonly: {
            type: Boolean,
            default: false
        },
        size: String,
        prefixIcon: String,
        suffixIcon: String,
        leftIcon: String,
        rightIcon: String,
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        caption_name: {
            type: String,
            default: 'label'
        }
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? '' : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        const hasSlotPrefix = computed(() => {
            return context.slots.prefix
        })
        const hasSlotSuffix = computed(() => {
            return context.slots.suffix
        })
        // 弃用前后置内容
        const hasSlotPrepend = computed(() => {
            return context.slots.prepend
        })
        const hasSlotAppend = computed(() => {
            return context.slots.append
        })

        const input = () => {
            context.emit('input')
        }
        const focus = () => {
            context.emit('focus')
        }
        const blur = () => {
            context.emit('blur')
        }
        // 回车
        const enter = () => {
            context.emit('enter')
        }

        const prefixClick = () => {
            context.emit('prefixClick')
        }

        const suffixClick = () => {
            context.emit('suffixClick')
        }

        const op = ref();

        // 弹出绑定对话框
        const openBindingDialog = (event) => {
            if(!props.readonly) {
                op.value.toggle(event)
            }
        }
        
        const keyword = ref('')
        const selectedItem = ref()

        // 查询
        const clickQuery = () => {
            context.emit('onQuery', keyword.value)
        }

        // 选中
        const onSelect = (event) => {
            text.value = event.data[props.caption_name]
            op.value.hide();
        }

        return {
            text,
            hasSlotPrefix,
            hasSlotSuffix,
            hasSlotPrepend,
            hasSlotAppend,
            input,
            focus,
            blur,
            op,
            openBindingDialog,
            keyword,
            clickQuery,
            selectedItem,
            onSelect,
            prefixClick,
            suffixClick,
            enter
        }
    }
}
</script>
